<template>
  <v-container
    id="finaliza-compra-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO ------------------------------------------------->
        <usuario-nao-identificado-form
          v-if="!usuarioIdentificado"
          :titulo="$t('lista-pedido')"
        />
        <base-material-card
          v-else
          :color="corPrimaria"
          :title="$t('lista-pedido')"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              <v-icon
                id="iconDocument"
                class="text-h2"
              >
                mdi-file-document-multiple
              </v-icon>
              Meus Pedidos
            </div>
          </template>
        </base-material-card>
        <v-divider class="mb-5" />
        <v-row>
          <v-col cols="12">
            <div
              v-if="pedidosList"
              id="pedidoIten"
              class="col-12"
            >
              <v-col
                cols="12"
                lg="12"
              >
                <div class="col-12">
                  <div>
                    <ul id="ul_product">
                      <li
                        v-for="pedido in pedidosList"
                        id="pedidoId"
                        :key="pedido.id"
                        class="col-12 lg-12 mb-4 my-2"
                      >
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th
                                  id="idNPedidoCliente"
                                  class="text-left"
                                  width="150px"
                                  style="color: black"
                                >
                                  Código
                                </th>
                                <th
                                  id="idNumeroPedido"
                                  class="text-left"
                                  width="180px"
                                  style="color: black"
                                >
                                  Nº Pedido Magis TI
                                </th>
                                <th
                                  id="idStatus"
                                  class="text-left"
                                  width="150px"
                                  style="color: black"
                                >
                                  Status
                                </th>
                                <th
                                  id="idTotal"
                                  class="text-left"
                                  width="110px"
                                  style="color: black"
                                >
                                  Total
                                </th>
                                <th
                                  id="idData"
                                  class="text-left"
                                  width="130px"
                                  style="color: black"
                                >
                                  Data Cadastro
                                </th>
                                <th
                                  id="idData"
                                  class="text-left"
                                  width="130px"
                                  style="color: black"
                                >
                                  Previsão de Entrega
                                </th>
                                <th
                                  id="idNf"
                                  class="text-left"
                                  width="120px"
                                  style="color: black"
                                >
                                  Nota Fiscal
                                </th>
                                <th
                                  id="idChaveNf"
                                  class="text-left"
                                  width="370px"
                                  style="color: black"
                                >
                                  Chave nfe
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  id="idNPedidoCliente"
                                  class="text-left"
                                >
                                  {{ pedido.id }}
                                </td>
                                <td
                                  id="idNumeroPedido"
                                  class="text-left"
                                >
                                  {{ pedido.numPedido }}
                                </td>
                                <td
                                  id="idStatus"
                                  class="text-left"
                                >
                                  {{ pedido.status }}
                                </td>
                                <td
                                  id="idTotal"
                                  class="text-left"
                                >
                                  {{ pedido.total }}
                                </td>
                                <td
                                  id="idData"
                                  class="text-left"
                                >
                                  {{ pedido.dataCadastro }}
                                </td>
                                <td
                                  id="idData"
                                  class="text-left"
                                >
                                  {{ pedido.dataEntrega }}
                                </td>
                                <td
                                  id="idNf"
                                  class="text-left"
                                >
                                  {{ pedido.notaFiscal }}
                                </td>
                                <td
                                  id="idChaveNf"
                                  class="text-left"
                                >
                                  <a
                                    v-if="pedido.chaveNfe !== '-'"
                                    :href="href + pedido.chaveNfe + '&'"
                                    target="_blank"
                                  >
                                    <v-icon
                                      id="iconNfe"
                                      class="text-h2"
                                      :color="corPrimaria"
                                    >
                                      mdi-receipt-outline
                                    </v-icon>
                                  </a>
                                  {{ pedido.chaveNfe }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-data-table
                          id="headers"
                          :headers="headers"
                          :items="pedido.itensPedido"
                          hide-default-footer
                          disable-sort
                          class="elevation-1"
                          style="color: black"
                        />
                        <div id="linhaHorizontal_listapedido" />
                      </li>
                    </ul>
                    <v-pagination
                      v-if="paginaVisible"
                      v-model="pagina"
                      :length="limitePagina"
                      circle
                      @input="carregaPagina(pagina)"
                    />
                  </div>
                </div>
              </v-col>
            </div>
            <div
              v-else
            >
              <h3 class="text-center">
                Não há pedidos.
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../services/utils'
  import ListaPedido from '../../../services/listapedidoservice'

  export default {
    name: 'PageListaPedidos',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      valid: true,
      username: localStorage.username,
      tokencontrato: localStorage.tokencontrato,
      contrato_id: localStorage.contrato_id,
      usuario_id: 0,
      pedidosList: [],
      corPrimaria: localStorage.corPrimaria,
      search: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      href: 'https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConteudo=7PhJ+gAVw2g=&tipoConsulta=resumo&nfe=',
      headers: [
        { text: 'Produto', value: 'nome', width: '45%', class: 'black--text title' },
        { text: 'Preço', value: 'precoExibicao', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', width: '15%', align: 'center', class: 'black--text title' },
        { text: 'Peça(s)', value: 'pecas', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Caixa(s)', value: 'caixa', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Sub Total', value: 'subtotal', width: '10%', class: 'black--text title' },
      ],
      cart: 0,
      limitePagina: 0,
      pagina: 1,
      paginaVisible: false,
      dialog: {
        visible: false,
        message: '',
      },
    }),

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true

          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')

          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
          localStorage.removeItem('username')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')
          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')
          this.$router.push('/login')
        }
      } else {
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('produtoId')
        this.$router.push('/login')
      }
    },

    methods: {
      carregaForm () {
        ListaPedido.usuario(this.username, this.contrato_id).then(resposta => {
          this.usuario_id = resposta.data.usuarioId
          this.carregaListaPedidos()
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.msg + ' - Usuário não encontrado')
          }
        })
      },

      async carregaListaPedidos () {
        await ListaPedido.showPedido(this.usuario_id, this.contrato_id, this.pagina).then(resposta => {
          if (resposta.data.limitePagina > 1) {
            this.paginaVisible = true
            this.limitePagina = resposta.data.limitePagina
          }

          this.pedidosList = resposta.data.pedidos

          const pedidolista = this.pedidosList.map((value) => {
            var listapedido = ({
              id: value.id,
              status: value.status,
              numPedido: !value.idPedidoMagisTi ? '-' : value.idPedidoMagisTi,
              total: value.totalPedido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              dataCadastro: value.dataCadastro,
              notaFiscal: value.notaFiscal,
              chaveNfe: value.chaveNfe ? value.chaveNfe : '-',
              dataEntrega: value.dataEntrega ? value.dataEntrega : '-',
              itensPedido: value.itensPedido.map((item) => {
                var itenslist = ({
                  nome: item.nome,
                  precoExibicao: item.preco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  quantidade: item.quantidade ? item.quantidade : '-',
                  pecas: item.pecas ? item.pecas : '-',
                  caixa: item.caixa ? item.caixa : '-',
                  subtotal: item.subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  status: value.status,
                })

                return itenslist
              }),
            })

            return listapedido
          })

          this.pedidosList = pedidolista

          this.order()
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      carregaPagina (value) {
        this.pagina = value

        this.carregaListaPedidos()
      },

      order () {
        this.pedidosList.sort(function (a, b) {
          if (a.id > b.id) {
            return -1
          } else {
            return true
          }
        })
      },

      formatDate (data) {
        var date = data.substring(0, 10)
        var ano = date.substring(0, 4)
        var x = date.substring(5)
        var mes = x.substring(0, 2)
        var dia = date.substring(8)

        return dia + '/' + mes + '/' + ano
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass" >
  #iconDocument
    margin-bottom: 5px

  #finaliza-compra-form
    margin-top: 4em

  #medicalRecordHome
  $record-text-size:14px

  #ul_product
    list-style-type: none
    margin-left: -3rem

  #pedidoId
     border-style: none

  #itensPedido
    margin-left: 1rem
    margin-top: 1rem
    display: flex
    -moz-box-align: center
    align-items: center
    font-weight: bold
    font-size: 14px

  #idNumeroPedido
    font-weight: bold
    font-size: 12px

  #idStatus
    font-weight: bold
    font-size: 12px

  #idTotal
    font-weight: bold
    font-size: 12px

  #idNPedidoCliente
    font-weight: bold
    font-size: 12px

  #idData
    font-weight: bold
    font-size: 12px

  #idNf
    font-size: 12px
    font-weight: bold

  #idChaveNf
    font-weight: bold
    font-size: 12px

  #ul_Itens
    list-style-type: none
    margin-left: -2.5rem

  #linhaHorizontal_listapedido
    width: 100%
    border: 2px dashed gray
    margin-top: 2rem
    margin-bottom: -2rem

  #iconNfe
    font-size: 25px !important

</style>
